import React, { useState, useCallback } from "react";
import "../Card.css";
import likeEmpty from "../like_empty.png"; 
import likeFilled from "../like_filled.png"; 
import dislikeEmpty from "../dislike_empty.png"; 
import dislikeFilled from "../dislike_filled.png"; 
import { setLikedDb, setDislikedDb } from "../firebase";


interface CardProps {
  setLikedCount: (count: number) => void;
  setDislikedCount: (count: number) => void;
  likedCount: number;
  dislikedCount: number;
  recipe: any;
  disableButtons?: boolean;

}

export default function Card({
  setLikedCount, 
  setDislikedCount, 
  likedCount, 
  dislikedCount, 
  recipe, 
  disableButtons
}: CardProps) {

  const [liked, setLiked] = useState(recipe.liked);
  const [disliked, setDisliked] = useState(recipe.disliked);
  const [showDetails, setShowDetails] = useState(false);

  const showDetailsOnClick = () => {
    setShowDetails(!showDetails);
  };


  const likeOnClick = () => {
    setLiked(!liked);
    if (disliked === true && dislikedCount > 0) {
      setDislikedCount(dislikedCount - 1)
    }
    setDisliked(false);
    setLikedDb(recipe.uid, recipe.id, !liked)
    if(!liked === false) {
      setLikedCount(likedCount - 1);
    } else {
      setLikedCount(likedCount + 1)
    }
  };

  const dislikeOnClick = () => {
    setDisliked(!disliked);
    if (liked === true && likedCount > 0) {
      setLikedCount(likedCount - 1)
    }
    setLiked(false);
    setDislikedDb(recipe.uid, recipe.id, !disliked)
    if(!disliked === false) {
      setDislikedCount(dislikedCount - 1);
    } else {
      setDislikedCount(dislikedCount + 1);
    }
  };

  return (
    <div className="border flex-col md:flex-row md:items-start border-blue-400 px-3 py-4" style={{backgroundColor: "#FFFFFF"}}>
      <div className="card-header">
        <div className="card-title-group">
          <h5 className="card-title"><strong>{recipe.title}</strong></h5>
          <div className="card-date"><strong>Number of Ingredients: {recipe.ingredientsNum}, Minutes: {recipe.minutes} </strong></div>
        </div>
      </div>
      <div className="card-text"><strong>Description: </strong>{recipe.description}</div>
      
        <button onClick = {() => {showDetailsOnClick()}}>  
          {showDetails ? <div className="card-button">Hide details ▲</div> :  <div className="card-button">See details ▼</div>}
        </button>

      {showDetails && <div className="card-text"><strong>Ingredients: </strong>{recipe.ingredients}</div>}
      {showDetails && 
        <div className="card-text">
          <strong>Steps: </strong>
          {recipe.steps.map(step => {
            return (
              <>
              <br/>
              {step}
              </>
            )
          })}
        </div>
      }
      {!disableButtons && 
        <div className="card-like-bar">
          <button onClick = {() => {likeOnClick()}}>        
            {liked ? (
              <img className="card-like-icon" src={likeFilled} alt="Logo"/>
            ) : (
              <img className="card-like-icon" src={likeEmpty} alt="Logo"/>
            )}
          </button>
          <button onClick = {() => {dislikeOnClick()}}>        
            {disliked ? (
              <img className="card-like-icon" src={dislikeFilled} alt="Logo"/>
            ) : (
              <img className="card-like-icon" src={dislikeEmpty} alt="Logo"/>
            )}
          </button>
        </div>
      }  
    </div>
  );
}